import LoadingIndicator from "@storeblocks/loading-indicator";
import { StyledAlert } from "App/global-style";
import { VALUE_TYPE } from "Components/NumberValue";
import { useTexts } from "Components/TextContext";
import { getPriceFormatFromValue } from "Formatting/index";
import { isDefined } from "Utils/functions";
import React from "react";
import { InsuranceSumFeedback } from "./styled";

interface Props {
  errorMessage: string;
  isCoverageTooHigh: boolean;
  suggestedInsuranceAmount: number | undefined | null;
  isLoadingSuggestedInsuranceAmount: boolean;
}

export const Feedback = ({
  errorMessage,
  isCoverageTooHigh,
  suggestedInsuranceAmount,
  isLoadingSuggestedInsuranceAmount,
}: Props): React.ReactElement => {
  const { getText } = useTexts();
  const feedback = getText(
    "housecontentscalculator.feedback.calculatedcoveragesum",
    {
      variables: {
        houseContentsCalculatorCoverageSum: isDefined(suggestedInsuranceAmount)
          ? getPriceFormatFromValue(suggestedInsuranceAmount, VALUE_TYPE.NOK)
          : "",
      },
    },
  );
  return (
    <div>
      <InsuranceSumFeedback>
        <>
          {feedback}
          {isLoadingSuggestedInsuranceAmount && <LoadingIndicator />}
        </>
      </InsuranceSumFeedback>

      {isCoverageTooHigh && <StyledAlert title={errorMessage} />}
    </div>
  );
};
